<script>
export default {
  name: 'file-preview',
  props: {
    file: { type: File, required: true }
  },
  data () {
    return {
      previewUrl: null,
      isLoading: false
    }
  },
  mounted () {
    try {
      var reader = new FileReader()
      this.isLoading = true
      reader.onload = e => {
        this.previewUrl = e.target.result
        this.isLoading = false
      }
      reader.readAsDataURL(this.file)
    } catch (error) {
      this.isLoading = false
    }
  },
  computed: {
    isImage () {
      return this.file && this.file.type.match('image.*')
    }
  }
}
</script>
<template>
  <g-overlay :show="isLoading">
    <div
      class="avatar-lg img-thumbnail"
      :style="{
        backgroundImage: `url(${previewUrl})`,
        backgroundSize: 'cover'
      }"
      v-if="isImage"
    >
      &nbsp;
    </div>
    <div
      class="avatar-lg d-flex align-items-center justify-content-center fa-2x text-secondary border bg-light"
      v-else
    >
      <g-file-icon :content-type="file.type" />
    </div>
  </g-overlay>
</template>
